import { render } from "./transactionConversion.vue?vue&type=template&id=48f960f6&scoped=true"
import script from "./transactionConversion.vue?vue&type=script&lang=js"
export * from "./transactionConversion.vue?vue&type=script&lang=js"

import "./transactionConversion.vue?vue&type=style&index=0&id=48f960f6&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f960f6"]])

export default __exports__